export const DASHBOARD_DESCRIBE: string = 'dashboard';